<div *ngIf="formContent.formAttribute">
  <app-form-constructor-base [dataStrategy]="dataStrategy" [formContent]="formContent"></app-form-constructor-base>
</div>
